// extracted by mini-css-extract-plugin
export default {"TextFieldLabel":"styles_TextFieldLabel__Yr5XH","contactItem":"styles_contactItem__AkHDe","contactIconItem":"styles_contactIconItem__to3wf","icon":"styles_icon__IIzs+"};